import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_safeInsets20bpe8v7txtx4 as get_safeInsets } from '../ViewContextExtensions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../models/data.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../models/Rect.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function applySafeInsets(_this__u8e3s4, left, top, right, bottom) {
  left = left === VOID ? true : left;
  top = top === VOID ? true : top;
  right = right === VOID ? true : right;
  bottom = bottom === VOID ? true : bottom;
  var s = get_safeInsets(_this__u8e3s4);
  reactive(_this__u8e3s4, ($this$reactive) => {
    var full = $this$reactive.daj(s);
    var tmp0_left = left ? full.mb2_1 : get_px(0);
    var tmp1_right = right ? full.ob2_1 : get_px(0);
    var tmp2_top = top ? full.nb2_1 : get_px(0);
    var tmp3_bottom = bottom ? full.pb2_1 : get_px(0);
    _this__u8e3s4.iba(Edges().dd0(tmp0_left, tmp2_top, tmp1_right, tmp3_bottom));
    return Unit_instance;
  });
}
//region block: exports
export {
  applySafeInsets as applySafeInsets3lsxkfxcwtdd8,
};
//endregion

//# sourceMappingURL=safeInsetsHelpers.mjs.map
